module.exports = __webpack_public_path__ + "img/primula.90122c92.webp";